import { css } from "@compiled/react";

import { Picture } from "@/components/wpl/image/src";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const RovoDevAgentsLogo = () => {
    const { src, alt } = checkFeatureFlagGate(
        featureFlags.enableRovoDevStandardSignup
    )
        ? {
              src: `https://dam-cdn.atl.orangelogic.com/AssetLink/5t47pkm4i4ohq647450a58xbtp5m5f08.svg`,
              alt: "Rovo Dev Logo"
          }
        : {
              src: `https://dam-cdn.atl.orangelogic.com/AssetLink/6o65b84k7gkin5q8y7g7tbf12116y058.svg`,
              alt: "Rovo Dev Agents Logo"
          };

    const cmsLogoStyle = css({
        height: "48px"
    });

    return (
        <Picture
            image={{
                src,
                alt
            }}
            css={cmsLogoStyle}
            key={"devai.ondemand"}
        />
    );
};
